<template>
  <v-container
    class="reports pa-0"
    fill-height
    fluid
  >
    <v-card flat>
      <v-card-title class="body-2 d-block px-3 pb-0">
        <span class="body-2 font-weight-medium">
          {{ $tc('labels.report', 1) }}
        </span>
        <v-btn
          class="float-right mt-n1"
          icon
          small
          @click="$emit('close')"
        >
          <v-icon small>
            fal fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-tabs
        v-model="selectedTab"
        class="px-3"
        mobile-breakpoint=""
        :show-arrows="false"
        slider-color="accent"
        slider-size="3"
      >
        <v-tab
          class="px-6"
          href="#shifts"
        >
          {{ $t('labels.shifts') }}
        </v-tab>
        <v-tab
          class="px-6"
          href="#events"
        >
          {{ $tc('labels.event', 2) }}
        </v-tab>
        <v-tab
          class="px-6"
          href="#staffing"
        >
          {{ $t('labels.staffing') }}
        </v-tab>
        <v-tab
          class="px-6"
          href="#productivity"
        >
          {{ $t('labels.productivity') }}
        </v-tab>
        <v-tab
          class="px-6"
          href="#requests"
        >
          {{ $tc('labels.request', 2) }}
        </v-tab>
        <v-tab
          class="px-6"
          href="#open-shifts"
        >
          {{ $tc('labels.openShift', 2) }}
        </v-tab>
      </v-tabs>
      <!-- Each report loads the first time its tab is opened, then stays mounted to keep its filters and page. -->
      <v-tabs-items
        v-model="selectedTab"
        touchless
      >
        <v-tab-item
          :reverse-transition="false"
          :transition="false"
          value="shifts"
        >
          <ShiftReport
            :content-height="contentHeight"
            :show-close-button="showCloseButton"
            :show-title="false"
            @close="$emit('close')"
          />
        </v-tab-item>
        <v-tab-item
          :reverse-transition="false"
          :transition="false"
          value="events"
        >
          <EventReport
            :content-height="contentHeight"
            :show-close-button="showCloseButton"
            :show-title="false"
            @close="$emit('close')"
          />
        </v-tab-item>
        <v-tab-item
          :reverse-transition="false"
          :transition="false"
          value="staffing"
        >
          <StaffingDashboard :content-height="contentHeight" />
        </v-tab-item>
        <v-tab-item
          :reverse-transition="false"
          :transition="false"
          value="productivity"
        >
          <ProductivityDashboard :content-height="contentHeight" />
        </v-tab-item>
        <v-tab-item
          :reverse-transition="false"
          :transition="false"
          value="requests"
        >
          <RequestsDashboard :content-height="contentHeight" />
        </v-tab-item>
        <v-tab-item
          :reverse-transition="false"
          :transition="false"
          value="open-shifts"
        >
          <OpenShiftsDashboard :content-height="contentHeight" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import EventReport from '@/components/scheduling/reports/EventReport';
import ShiftReport from '@/components/scheduling/reports/ShiftReport';

export default {
  components: {
    EventReport,
    // The dashboards are loaded with their chart library only when their tab is first opened.
    OpenShiftsDashboard: () => import(/* webpackChunkName: "open-shifts-dashboard" */ '@/components/scheduling/reports/OpenShiftsDashboard'),
    ProductivityDashboard: () => import(/* webpackChunkName: "productivity-dashboard" */ '@/components/scheduling/reports/ProductivityDashboard'),
    RequestsDashboard: () => import(/* webpackChunkName: "requests-dashboard" */ '@/components/scheduling/reports/RequestsDashboard'),
    ShiftReport,
    StaffingDashboard: () => import(/* webpackChunkName: "staffing-dashboard" */ '@/components/scheduling/reports/StaffingDashboard')
  },
  props: {
    showCloseButton: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      // Leaves room for the tabs above each report.
      contentHeight: 'calc(88vh - 48px)',
      selectedTab: 'shifts'
    };
  }
};
</script>

<style lang="scss">
.reports {
  > .v-card {
    background: transparent;
    height: 100%;
    width: 100%;
  }
  // Space between the tabs and the report. The tabs' wrapper element can't take a class.
  .v-tabs .v-slide-group__wrapper {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
